import React, { CSSProperties, useState } from 'react'
import CloseButton from '../CloseButton'
import Button from '../Button'
import { Wrapper } from './styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle, faExclamationTriangle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'

type Props = {
  text?: string
  textComponent?: React.ReactElement
  storageId?: string
  storageType?: 'localStorage' | 'sessionStorage'
  style?: CSSProperties
  type?: 'info' | 'warning' | 'error'
  nonDismissable?: boolean
  actionButton?: {
    label: string
    onClick?: () => void
  }
}

export default function InfoPanel({
  text,
  textComponent,
  storageId,
  storageType = 'localStorage',
  style,
  type = 'info',
  nonDismissable,
  actionButton,
}: Props) {
  const [isDismissed, setIsDismissed] = useState(false)

  const storage = storageType === 'sessionStorage' ? sessionStorage : localStorage

  if (isDismissed || (storageId && storage['hasDismissed:' + storageId])) {
    return null
  }

  const icon = type === 'error' ? faTimesCircle : type === 'warning' ? faExclamationTriangle : faInfoCircle

  const dismiss = () => {
    setIsDismissed(true)
    if (storageId) {
      storage['hasDismissed:' + storageId] = true
    }
  }

  return (
    <Wrapper className="panel" style={style} isWarning={type === 'warning'} isError={type === 'error'}>
      <p>
        <FontAwesomeIcon icon={icon} />
        {textComponent || text}
        {actionButton && (
          <Button
            text={actionButton.label}
            onClick={actionButton.onClick || dismiss}
            variant="as-text"
            style={{ padding: 0, height: 'auto' }}
          />
        )}
      </p>
      {storageId === 'personalize-info' && <div className="floating-emoji">👉</div>}
      {!nonDismissable && <CloseButton title="Închide" onClick={dismiss} />}
    </Wrapper>
  )
}
